import React from "react";

const Button = ({ 
  children, 
  loading = false, 
  disabled = false, 
  type = "button", 
  className = "", 
  ...props 
}) => {
  return (
    <button
      type={type}
      disabled={loading || disabled}
      className={`btn-app ${className}`}
      {...props}
    >
      {loading ? (
        <span className="spinner-loader"></span>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;